import { customerInfoSchema, deliveryInfoSchema, invoiceInfoSchema } from '../form-configs/schema';
import { customerInfoData, deliveryInfoData, invoiceInfoData } from '../form-configs/data';
import { customerInfoLayout, deliveryInfoLayout } from '../form-configs/layout';

export const issueInvoice = context => ({
  schema: {
    ...customerInfoSchema(context),
    ...invoiceInfoSchema(context),
    ...deliveryInfoSchema(context),
  },
  formModel: {
    ...customerInfoData,
    ...invoiceInfoData,
    ...deliveryInfoData,
  },
  layout: {
    ...customerInfoLayout,
    'div.grid.grid-cols-1:0': {
      div: {
        slot: 'invoice-info-title',
      },
      'div.grid.grid-cols-2.gap-x-30': {
        'div.col-span-1.md-col-span-2': { field: 'invoice_type' },
        'div.col-span-1.md-col-span-2:0': { field: 'template_code' },
        'div.col-span-1.md-col-span-2:1': { field: 'invoice_common_code' },
        'div.col-span-1.md-col-span-2:2': { field: 'date_created' },
        'div.col-span-1.md-col-span-2:3': { field: 'payment_method' },
        'div.col-span-1.md-col-span-2:4': { field: 'currency_code' },
        'div.col-span-1.md-col-span-2:5': { field: 'foreign_rate' },
      },
    },
    ...deliveryInfoLayout,
  },
});

export default issueInvoice;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-definition/issue_invoice.js